import { APIHelpSection } from '@partnerconnect-monorepo/types/HelpSection';
import { HelpSectionView } from './HelpSectionView';
import { useHelpSection } from './HelpSection.hooks';

interface HelpSectionProps {
  helpSection: APIHelpSection;
}

export const HelpSection = ({ helpSection }: HelpSectionProps) => {
  const { isEditing, setIsEditing } = useHelpSection();

  return (
    <HelpSectionView
      helpSection={helpSection}
      isEditing={isEditing}
      setIsEditing={setIsEditing}
    />
  );
};
